module.exports = __webpack_public_path__ + "img/gold-diplom.95b229ee.svg";